<template>
<div>
  <banner :title="error"  :active.sync="showBanner" :error="error" />
  <jobseeker-signup title="Signup"
                    subtitle="Jobseeker"
                    number="02"
                    description="Job preferences."
                    detail="See the jobs you really want"
                    v-on:continue="onContinue"
                    :loading="loading"
                    :disabled="checkFormData"
                    :tasks="tasks"
                    :skip="true"
                    @onSkip="onSkip"
                    >
    <jobseeker-form v-on:error="onError" />
  </jobseeker-signup>
</div>
</template>

<script>
import JobseekerSignup from '@/templates/jobseeker-signup'
import JobseekerForm from '@/components/jobseekers/jobseeker-form'
import Banner from '@/components/general/banner'
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import PaperclipHighlighted from '@/assets/paperclip-highlighted.svg'
import PaperclipNormal from '@/assets/paperclip.svg'
import Actions from '@/api/actions'

export default {
  components: { JobseekerSignup, JobseekerForm, Banner },
  data () {
    return {
      error: false,
      showBanner: false,
      loading: false,
      tasks: [{
        name: 'Profile',
        completed: true
      }, {
        name: 'Job preferences',
        completed: false
      }],
      errorActive: false
    }
  },
  computed: {
    resumeName () {
      if (this.resume && this.resume.name) {
        return this.resume.name
      } else {
        return ''
      }
    },
    paperclipImage () {
      if (this.resume && this.resumeName.length > 0) {
        return PaperclipHighlighted
      } else {
        return PaperclipNormal
      }
    },
    ...mapGetters('jobseekerForm', {
      profileFormData: 'formData'
    }),
    ...mapState('jobseekerProfiles', [
      'jobseekerProfile'
    ]),
    checkFormData () {
      const formData = this.profileFormData
      if (formData.locations.length !== 0 && formData.roles.length !== 0 && formData.contracts.length !== 0) {
        return false
      }
    }
  },
  methods: {
    ...mapActions('jobseekerProfiles', [
      'getJobseekerProfile',
      'updateJobseekerProfile'
    ]),
    ...mapActions('jobseekerForm', [
      'loadWithProfile'
    ]),
    ...mapMutations('notifications', [
      'setShowProfileBanner'
    ]),
    async onContinue () {
      if (this.errorActive) return
      this.loading = true
      const formData = this.profileFormData
      try {
        await this.updateJobseekerProfile(formData)
        this.setShowProfileBanner(true)
        if (this.$intercom) {
          this.$intercom.update({ completed_profile: true })
        }
        if (this.$ga) {
          this.$ga.event('Onboarding', 'Complete', 'Jobseeker', 2)
        }
        const { route } = await Actions.signup()
        this.$router.push(route)
      } catch (error) {
        this.error = error
        this.showBanner = true
      }
      this.loading = false
    },
    onError (value) {
      this.errorActive = value
    },
    async onSkip () {
      this.$ga.event('Onboarding', 'Skip', 'Jobseeker', 2)
      const { route } = await Actions.signup()
      this.$router.push(route)
    }
  },
  async mounted () {
    await this.getJobseekerProfile()
    const profile = this.jobseekerProfile
    this.loadWithProfile(profile)
  }
}
</script>

<style lang="scss" scoped>

.input-file {
  overflow: hidden;
  position: absolute;
  visibility: hidden;
}

.button.is-static {
  font-weight: normal;
}

</style>



// WEBPACK FOOTER //
// src/pages/jobseeker-signup-2.vue